exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1MPboMD2e6ubd-{background-color:transparent;border:none;box-shadow:none;color:#172b4d;padding:0;text-decoration:none}._1MPboMD2e6ubd-:active,._1MPboMD2e6ubd-:hover{background-color:transparent;border:none;box-shadow:none;color:#172b4d;color:#505f79;cursor:pointer;outline:0}", ""]);

// exports
exports.locals = {
	"closeButton": "_1MPboMD2e6ubd-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/buttons/close-button/close-button.less
// module id = tzbS
// module chunks = 24